module.exports = __webpack_public_path__ + "static/media/datos_blanco.874439a3.svg";